import { FC } from 'react';
import { DataRoomAccessStatus, DataRoomRecipientKind } from 'shared';

import { AppFormattedMessage } from '../../../../../components/app-formatted-message/index';
import { Tag, TagVariant } from '../../../../../components/tag/index';
import { StringKey } from '../../../../../lang/index';

/**
 * The status a person holds IN THIS ROOM. Deliberately its own badge: the Invite modal shows a
 * badge for the person's standing in the COMPANY, and the two use overlapping words for
 * different things — someone can be Active here while Inactive in the company.
 */
const ACCESS_STATUS: Record<DataRoomAccessStatus, { label: StringKey; variant: TagVariant }> = {
  [DataRoomAccessStatus.ACTIVE]: { label: 'ACTIVE', variant: TagVariant.GREEN },
  [DataRoomAccessStatus.PENDING]: { label: 'PENDING', variant: TagVariant.YELLOW },
  [DataRoomAccessStatus.REVOKED]: { label: 'REVOKED', variant: TagVariant.RED },
};

export const AccessStatusBadge: FC<{ status: DataRoomAccessStatus }> = ({ status }) => {
  const { label, variant } = ACCESS_STATUS[status];

  return <Tag title={<AppFormattedMessage id={label} />} variant={variant} />;
};

export const RecipientKindLabel: FC<{ recipientKind: DataRoomRecipientKind }> = ({
  recipientKind,
}) => (
  <AppFormattedMessage
    id={recipientKind === DataRoomRecipientKind.INTERNAL ? 'INTERNAL' : 'EXTERNAL'}
  />
);
